import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard {
  canDeactivate(component: any, route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('CanDeactivateGuard')
    return true
  }
}
